<!--
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-02-14 16:22:17
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-11-14 14:43:19
 * @FilePath: /designcenter/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="loading-container" v-if="!isInitialized">Loading...</div>
  <div v-else>
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, watch, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { initProject } from '@/api/modules/project'
import { useHeaderStore } from '@/store/header'
import { useProjectStore } from '@/store/project'
import { storeToRefs } from 'pinia'
import { Cookie, handleFsLink, setLoginUrl } from '@/utils'
import * as Sentry from '@sentry/vue'
import { useUserStore } from '@/store/user'
import { useWebsiteInfoStore } from '@/store/websiteInfo'
import { PageTimeTracker } from '@/utils/analytics'
const headerStore = useHeaderStore()
const projectStore = useProjectStore()
const route = useRoute()
const userStore = useUserStore()
const websiteInfoStore = useWebsiteInfoStore()

const { isInitialized } = storeToRefs(projectStore)
let tracker: PageTimeTracker | null = null
// TODO: 权限校验应该在路由拦截器里面执行，并应该放在 App 的 onMounted 里面执行
onMounted(async () => {
  await nextTick()
  const token = Cookie.get('token_new') || route.query.token || location.search.split('token=')[1] || ''
  projectStore.setCurrentProjectId(null)
  projectStore.setCurrentTemplateId(null)
  console.log('token', token)
  if (token) {
    const params = new URLSearchParams(window.location.search)
    if (import.meta.env.MODE == 'production') {
      tracker = new PageTimeTracker('Design Center')
    }
    if (params.get('projectId') && params.get('share')) {
      console.log('app_app')
      console.log(params)
      console.log(params.get('projectId'))
      console.log(params.get('share'))
      const projectId = params.get('projectId')
      if (projectId) {
        projectStore.setCurrentProjectId(parseInt(projectId))
        projectStore.setCurrentTemplateId(null)
      } else {
        console.error('projectId is missing in URL parameters')
      }
      projectStore.$patch(state => {
        state.isInitialized = true
      })
    } else {
      if (route.query.shareId) return
      initProject()
        .then((res: any) => {
          if (res.data.projectId) {
            projectStore.setCurrentProjectId(res.data.projectId)
            projectStore.$patch(state => {
              state.isInitialized = true
            })
            if (res.data.templateId || (res.data.templateId === 0 && res.data.isCustomized === 1)) {
              projectStore.setCurrentTemplateId(res.data.templateId)
            } else {
              nextTick(() => {
                headerStore.showSelectTemplatePopup()
              })
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  } else {
    if (
      location.host.includes('whgxwl.com') ||
      location.host.includes('design-center') ||
      location.host.includes('feisu')
    ) {
      console.log(handleFsLink(`/login.html?redirect=${setLoginUrl()}`), 'localtion')
      location.href = handleFsLink(`/login.html?redirect=${setLoginUrl()}`)
    }
  }
})
onUnmounted(() => {
  if (tracker) {
    tracker.destroy()
  }
})
watch(
  () => userStore.userInfo,
  userInfo => {
    if (userInfo) {
      Sentry.setUser({
        username: userStore?.userInfo?.customers_firstname + ' ' + userStore?.userInfo?.customers_lastname,
        email: userStore?.userInfo?.customers_email_address,
        //   websiteinfo: JSON.stringify(websiteInfoStore.$state)
      })
    }
  },
  { immediate: true }
)
</script>

<style lang="scss">
#mainApp {
  height: 100vh;
  width: 100vw;
}
</style>

<style lang="scss" scoped>
.loading-container {
  height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  @include font14;
}
</style>
